// import React from "react";
// import { motion } from "framer-motion";
// import bg from '../../../Assets/Home/AboutBg.png';
// import image from '../../../Assets/Home/AB.jpg';


// const features = [
//   {
//     icon: (
//       // Two phone/tablet devices
//       <svg viewBox="0 0 40 40" fill="none" className="w-8 h-8 text-orange-500" xmlns="http://www.w3.org/2000/svg">
//         <rect x="4" y="8" width="13" height="24" rx="3" stroke="currentColor" strokeWidth="1.8" />
//         <rect x="20" y="8" width="13" height="24" rx="3" stroke="currentColor" strokeWidth="1.8" />
//         <line x1="4" y1="27" x2="17" y2="27" stroke="currentColor" strokeWidth="1.5" />
//         <line x1="20" y1="27" x2="33" y2="27" stroke="currentColor" strokeWidth="1.5" />
//       </svg>
//     ),
//     title: "OUR MISSION",
//     description:
//       "Our mission is to provide high-quality IT solutions that drive growth, enhance productivity, and improve client outcomes. We are dedicated to providing exceptional service and support, building lasting relationships based on trust, collaboration, and shared success.",
//   },
//   {
//     icon: (
//       // Document with chip/circuit on top
//       <svg viewBox="0 0 40 40" fill="none" className="w-8 h-8 text-orange-500" xmlns="http://www.w3.org/2000/svg">
//         <rect x="6" y="14" width="28" height="20" rx="3" stroke="currentColor" strokeWidth="1.8" />
//         <line x1="6" y1="21" x2="34" y2="21" stroke="currentColor" strokeWidth="1.5" />
//         <line x1="12" y1="27" x2="20" y2="27" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
//         <line x1="12" y1="30" x2="24" y2="30" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
//         {/* Chip on top */}
//         <rect x="14" y="6" width="12" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" />
//         <line x1="17" y1="6" x2="17" y2="4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
//         <line x1="20" y1="6" x2="20" y2="4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
//         <line x1="23" y1="6" x2="23" y2="4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
//       </svg>
//     ),
//     title: "OUR VISION",
//     description:
//       "Our vision is to be a leading IT solution provider that empowers businesses to thrive in the digital age. We strive to be a trusted partner to our clients, delivering innovative solutions tailored to their unique needs and objectives.",
//   },
// ];

// export default function AboutHeroSection() {
//   return (
//     <section className="w-full bg-white py-8 lg:py-12 overflow-hidden">
//       <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center gap-12">

//         {/* ── LEFT: Image composition ── */}
//         <div style={{backgroundImage : `url(${bg})`}} className="flex-1 relative min-h-[580px] bg-cover bg-center flex items-center justify-center">

//           {/* Main person image */}
//           <motion.div
//             className="relative z-10"
//             initial={{ opacity: 0, x: -40 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
//           >
//             <img
//               src={image}
//               alt="Professional woman pointing"
//               className="w-[440px] h-[520px] object-cover object-top rounded-xl"
//               style={{
//                 filter: "drop-shadow(0 8px 32px rgba(0,0,0,0.10))",
//                 maskImage: "none",
//               }}
//             />
//           </motion.div>
//         </div>

//         {/* ── RIGHT: Content ── */}
//         <div className="flex-1 max-w-xl">
//           {/* Badge */}
//           <motion.div
//             initial={{ opacity: 0, y: -12 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.45 }}
//             className="mb-5"
//           >
//             <span className="inline-block px-5 py-1.5 rounded-full font-jakarta border border-gray-300 bg-gray-50 text-gray-600 text-xs font-semibold tracking-widest uppercase">
//               About Us
//             </span>
//           </motion.div>

//           {/* Heading */}
//           <motion.h1
//             initial={{ opacity: 0, y: 22 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.55, delay: 0.1 }}
//             className="text-2xl md:text-4xl lg:text-[45px] font-jakarta font-bold text-gray-900 leading-relaxed mb-5"
//           >
//             Harness the Power of{" "}
//             <span className="block mt-2 sm:mt-4">
//             Our IT <span className="text-orange-500">Solutions </span>
//             </span>
//           </motion.h1>

//           {/* Description */}
//           <motion.p
//             initial={{ opacity: 0, y: 14 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.48, delay: 0.18 }}
//             className="text-gray-500 text-[0.95rem] leading-relaxed mb-10"
//           >
//             At KGS Technology Group, we believe in the transformative power of IT solutions. Our team is passionate about helping our clients leverage the latest technologies to achieve their goals and stay ahead of the competition. We offer a wide range of IT services, including consulting, software development, system integration, and project management, tailored to meet each client's unique needs.
//           </motion.p>

//           {/* Feature cards — 2 columns */}
//           <motion.div
//             className="grid grid-cols-1 sm:grid-cols-2 gap-8"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5, delay: 0.26 }}
//           >
//             {features.map((f, i) => (
//               <motion.div
//                 key={i}
//                 whileHover={{ y: -4 }}
//                 transition={{ type: "spring", stiffness: 260, damping: 22 }}
//                 className="flex flex-col gap-3"
//               >
//                 {/* Icon box */}
//                 <div className="w-14 h-14 rounded-2xl bg-orange-50 flex items-center justify-center">
//                   {f.icon}
//                 </div>
//                 <h3 className="font-bold text-gray-900 text-[1rem]">{f.title}</h3>
//                 <p className="text-gray-500 text-[0.88rem] leading-relaxed">{f.description}</p>
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>

//       </div>
//     </section>
//   );
// }



import React from "react";
import { motion } from "framer-motion";
import bg from '../../../Assets/Home/AboutBg.png';
import image from '../../../Assets/Home/AB.jpg';


const features = [
  {
    icon: (
      // Two phone/tablet devices
      <svg viewBox="0 0 40 40" fill="none" className="w-8 h-8 text-orange-500" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="8" width="13" height="24" rx="3" stroke="currentColor" strokeWidth="1.8" />
        <rect x="20" y="8" width="13" height="24" rx="3" stroke="currentColor" strokeWidth="1.8" />
        <line x1="4" y1="27" x2="17" y2="27" stroke="currentColor" strokeWidth="1.5" />
        <line x1="20" y1="27" x2="33" y2="27" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
    title: "OUR MISSION",
    description:
      "Our mission is to provide high-quality IT solutions that drive growth, enhance productivity, and improve client outcomes. We are dedicated to providing exceptional service and support, building lasting relationships based on trust, collaboration, and shared success.",
  },
  {
    icon: (
      // Document with chip/circuit on top
      <svg viewBox="0 0 40 40" fill="none" className="w-8 h-8 text-orange-500" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="14" width="28" height="20" rx="3" stroke="currentColor" strokeWidth="1.8" />
        <line x1="6" y1="21" x2="34" y2="21" stroke="currentColor" strokeWidth="1.5" />
        <line x1="12" y1="27" x2="20" y2="27" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="12" y1="30" x2="24" y2="30" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        {/* Chip on top */}
        <rect x="14" y="6" width="12" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <line x1="17" y1="6" x2="17" y2="4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        <line x1="20" y1="6" x2="20" y2="4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        <line x1="23" y1="6" x2="23" y2="4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    ),
    title: "OUR VISION",
    description:
      "Our vision is to be a leading IT solution provider that empowers businesses to thrive in the digital age. We strive to be a trusted partner to our clients, delivering innovative solutions tailored to their unique needs and objectives.",
  },
];

export default function AboutHeroSection() {
  return (
    <section className="w-full bg-white py-8 lg:py-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center gap-12">

        {/* ── LEFT: Image composition ── */}
        <div style={{backgroundImage : `url(${bg})`}} className="flex-1 relative min-h-[580px] bg-cover bg-center flex items-center justify-center">

          {/* Main person image */}
          <motion.div
            className="relative z-10"
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
          >
            <img
              src={image}
              alt="Professional woman pointing"
              className="w-[440px] h-[520px] object-cover object-top rounded-xl"
              style={{
                filter: "drop-shadow(0 8px 32px rgba(0,0,0,0.10))",
                maskImage: "none",
              }}
            />
          </motion.div>
        </div>

        {/* ── RIGHT: Content ── */}
        <div className="flex-1 max-w-xl">

          {/* Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: 0.1 }}
            className="text-2xl md:text-4xl lg:text-[45px] font-jakarta font-bold text-gray-900 leading-relaxed mb-5"
          >
            Harness the Power of{" "}
            <span className="block mt-2 sm:mt-4">
            Our IT <span className="text-orange-500">Solutions </span>
            </span>
          </motion.h1>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.48, delay: 0.18 }}
            className="text-gray-500 text-[0.95rem] leading-relaxed mb-10"
          >
            At KGS Technology Group, we believe in the transformative power of IT solutions. Our team is passionate about helping our clients leverage the latest technologies to achieve their goals and stay ahead of the competition. We offer a wide range of IT services, including consulting, software development, system integration, and project management, tailored to meet each client's unique needs.
          </motion.p>

          {/* Feature cards — 2 columns */}
          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 gap-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.26 }}
          >
            {features.map((f, i) => (
              <motion.div
                key={i}
                whileHover={{ y: -4 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="flex flex-col gap-3"
              >
                {/* Icon box */}
                <div className="w-14 h-14 rounded-2xl bg-orange-50 flex items-center justify-center">
                  {f.icon}
                </div>
                <h3 className="font-bold text-gray-900 text-[1rem]">{f.title}</h3>
                <p className="text-gray-500 text-[0.88rem] leading-relaxed">{f.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>

      </div>
    </section>
  );
}